var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGsheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.224,
    y1: -0.224,
    x2: 1.224,
    y2: 0.776,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.155,
    y1: 0.314,
    x2: 1.111,
    y2: 0.757,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380",
    transform: "translate(-2746 -22865)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_114",
    "data-name": "Rectangle 114",
    width: 50,
    height: 50,
    transform: "translate(2746 22865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2993659_brand_brands_google_logo_logos_icon",
    "data-name": "2993659_brand_brands_google_logo_logos_icon",
    transform: "translate(2757 22874)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M26.933,7.978,18.955,0H5.659A2.659,2.659,0,0,0,3,2.659V29.251A2.659,2.659,0,0,0,5.659,31.91H24.273a2.659,2.659,0,0,0,2.659-2.659Z",
    fill: "#19b870"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M17.461,6.189a2.648,2.648,0,0,1-1.858-.76L22.779,12.6V6.189Z",
    transform: "translate(4.154 1.789)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M24.273,24.409H5.659A2.659,2.659,0,0,1,3,21.75v.332a2.659,2.659,0,0,0,2.659,2.659H24.273a2.659,2.659,0,0,0,2.659-2.659V21.75A2.659,2.659,0,0,1,24.273,24.409Z",
    transform: "translate(0 7.169)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M15,0V5.318a2.659,2.659,0,0,0,2.659,2.659h5.318Z",
    transform: "translate(3.955)",
    fill: "#80d8b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M17.659,6.409A2.659,2.659,0,0,1,15,3.75v.332a2.659,2.659,0,0,0,2.659,2.659h5.318l-.332-.332Z",
    transform: "translate(3.955 1.236)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M18.955,0H5.659A2.659,2.659,0,0,0,3,2.659v.332A2.659,2.659,0,0,1,5.659.332h13.3",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M7,9V22.3H20.3V9Zm11.966,3.989H14.313V10.33h4.654Zm-4.654,1.33h4.654v2.659H14.313Zm-1.33,2.659H8.33V14.318h4.654Zm0-6.648v2.659H8.33V10.33ZM8.33,18.307h4.654v2.659H8.33Zm5.983,2.659V18.307h4.654v2.659Z",
    transform: "translate(1.318 2.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M26.933,7.978,18.955,0H5.659A2.659,2.659,0,0,0,3,2.659V29.251A2.659,2.659,0,0,0,5.659,31.91H24.273a2.659,2.659,0,0,0,2.659-2.659Z",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGsheets);
export default __webpack_public_path__ + "static/media/icon-gsheets.15c1df842c8d6884a4b5d0ad8532fa18.svg";
export { ForwardRef as ReactComponent };